import LoadingPaper from '@components/LoadingPaper';
import { APP_ENV } from '@modules/consts';
import { log } from '@modules/logging';
import Download from '@mui/icons-material/Download';
import { Button, Grid, Typography } from '@mui/material';
import { memo } from 'react';
import QRCode from 'react-qr-code';

const getGooglePlayUrl = (): string => {
    switch (APP_ENV) {
        case 'sabol':
            return `https://play.google.com/store/apps/details?id=io.synergetx.chate`;
        case 'puppet-interview':
            return `https://play.google.com/store/apps/details?id=io.synergetx.puppetinterview`;
        case 'crest':
            return `https://play.google.com/store/apps/details?id=io.synergetx.share`;
        default:
            log(`**** ERROR: unrecognized APP_ENV [getGooglePlayUrl]`, { APP_ENV });
            return '';
    }
};

const getAppleUrl = (): string => {
    switch (APP_ENV) {
        case 'sabol':
            return `https://apps.apple.com/us/app/chat-e/id1482010930`;
        case 'puppet-interview':
        case 'crest':
        default:
            return '';
    }
};

function MobileAppLink() {
    const appleUrl = getAppleUrl();
    const googlePlayUrl = getGooglePlayUrl();

    return (
        <LoadingPaper
            style={{
                width: '85vw',
                minHeight: '95vh',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Grid
                container
                sx={{
                    justifyContent: 'space-evenly',
                    padding: '5vw',
                    width: '100%',
                }}
            >
                <Grid
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="h5">Get Android App</Typography>
                    <a href={googlePlayUrl} target="_blank">
                        <Button
                            color="secondary"
                            startIcon={<Download />}
                            sx={{ m: 5 }}
                            variant="outlined"
                        >
                            Tap to download
                        </Button>
                    </a>
                    <QRCode value={googlePlayUrl} />
                </Grid>
                {appleUrl ? (
                    <Grid
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h5">Get iOS (Apple) App</Typography>
                        <a href={appleUrl} target="_blank">
                            <Button
                                color="secondary"
                                startIcon={<Download />}
                                sx={{ m: 5 }}
                                variant="outlined"
                            >
                                Tap to download
                            </Button>
                        </a>
                        <QRCode value={appleUrl} />
                    </Grid>
                ) : null}
            </Grid>
        </LoadingPaper>
    );
}

export default memo(MobileAppLink);
